/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { BrandColors, Text } from '@blend/enterprise-components';
import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import { ColumnInstance } from 'react-table';
import { NotaryAPI } from '../../api/notary/types';
import { toUpper } from '@utils/lodash';

const styles = StyleSheet.create({
  tableHeaderContainer: {
    alignItems: 'center',
    display: 'flex',
  },
});

export const TableHeader: React.FC<{ column: ColumnInstance<NotaryAPI.Participant> }> = ({ column }) => {
  return (
    <div className={css(styles.tableHeaderContainer)}>
      <Text color={BrandColors.NIGHT} fontSize="sm" weight="semibold">
        {toUpper(column.id)}
      </Text>
    </div>
  );
};
